export default __webpack_public_path__ + "static/media/cat-image-2.4e193fd0.png";